import { AdvancedMessageTemplateJson } from 'types/domain';
import { v4 as uuid } from 'uuid';

interface AdvancedTemplateCategory {
    id: string;
    name: string;
}

const advancedTemplateCategories: AdvancedTemplateCategory[] = [
    {
        id: 'fundraising',
        name: 'Fundraising',
    },
    {
        id: 'holiday',
        name: 'Holiday',
    },

    {
        id: 'thank-you',
        name: 'Thank you',
    },
    {
        id: 'non-profit',
        name: 'Non profit',
    },
    {
        id: 'giving-tuesday',
        name: 'Giving Tuesday',
    },
];

const getAdvancedTemplateEmptyRow = () => ({
    container: {
        style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-repeat': 'no-repeat',
            'background-position': 'top left',
        },
    },
    content: {
        style: {
            'background-color': 'transparent',
            color: '#000000',
            width: '500px',
            'background-image': 'none',
            'background-repeat': 'no-repeat',
            'background-position': 'top left',
            'border-top': '0px solid transparent',
            'border-right': '0px solid transparent',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
        },
        computedStyle: {
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
            hideContentOnMobile: false,
            hideContentOnDesktop: false,
        },
    },
    columns: [
        {
            style: {
                'background-color': 'transparent',
                'border-bottom': '0px solid transparent',
                'border-left': '0px solid transparent',
                'border-right': '0px solid transparent',
                'border-top': '0px solid transparent',
                'padding-bottom': '5px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '5px',
            },
            modules: [],
            'grid-columns': 12,
            uuid: uuid(),
        },
    ],
    type: 'one-column-empty',
    uuid: uuid(),
});

const getAdvancedTemplateFooterRow = () => ({
    type: 'one-column-empty',
    uuid: uuid(),
    locked: true,
    columns: [
        {
            uuid: uuid(),
            style: {
                'border-top': '0px solid transparent',
                'border-left': '0px solid transparent',
                'padding-top': '10px',
                'border-right': '0px solid transparent',
                'padding-left': '0px',
                'border-bottom': '0px solid transparent',
                'padding-right': '0px',
                'padding-bottom': '10px',
                'background-color': '#ffffff',
            },
            modules: [
                {
                    type: 'mailup-bee-newsletter-modules-paragraph',
                    uuid: uuid(),
                    locked: true,
                    descriptor: {
                        style: {
                            'padding-top': '20px',
                            'padding-left': '10px',
                            'padding-right': '10px',
                            'padding-bottom': '10px',
                        },
                        paragraph: {
                            html: '<p>If you no longer wish to receive emails <a href="#" target="_blank" style="text-decoration: underline;" rel="noopener">unsubscribe here</a></p>',
                            style: {
                                color: '#000000',
                                direction: 'ltr',
                                'font-size': '14px',
                                'text-align': 'center',
                                'font-family': 'inherit',
                                'line-height': '120%',
                                'letter-spacing': '0px',
                            },
                            computedStyle: {
                                linkColor: '#3366ff',
                                paragraphSpacing: '16px',
                            },
                        },
                        mobileStyle: {},
                        computedStyle: {
                            hideContentOnAmp: false,
                            hideContentOnHtml: false,
                            hideContentOnMobile: false,
                            hideContentOnDesktop: false,
                        },
                    },
                },
                {
                    type: 'mailup-bee-newsletter-modules-paragraph',
                    uuid: uuid(),
                    locked: true,
                    descriptor: {
                        style: {
                            'padding-top': '10px',
                            'padding-left': '10px',
                            'padding-right': '10px',
                            'padding-bottom': '10px',
                        },
                        paragraph: {
                            html: '<p><code spellcheck="false" data-bee-type="mergetag" data-bee-code="" data-bee-name="Organization Address" data-bee-value="{{account.organization_address}}" data-mce-selected="inline-boundary"><q></q></code></p>',
                            style: {
                                color: '#777777',
                                direction: 'ltr',
                                'font-size': '13px',
                                'text-align': 'center',
                                'font-family': 'inherit',
                                'font-weight': '400',
                                'line-height': '120%',
                                'letter-spacing': '0px',
                            },
                            computedStyle: {
                                linkColor: '#0068a5',
                                paragraphSpacing: '16px',
                            },
                        },
                        mobileStyle: {},
                        computedStyle: {
                            hideContentOnAmp: false,
                            hideContentOnHtml: false,
                            hideContentOnMobile: false,
                            hideContentOnDesktop: false,
                        },
                    },
                },
            ],
            'grid-columns': 12,
        },
    ],
    content: {
        style: {
            color: '#000000',
            width: '500px',
            'border-top': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-right': '0px solid transparent',
            'border-bottom': '0px solid transparent',
            'border-radius': '0px',
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-repeat': 'no-repeat',
            'background-position': 'top left',
        },
        computedStyle: {
            verticalAlign: 'top',
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            hideContentOnDesktop: false,
            rowReverseColStackOnMobile: false,
        },
    },
    container: {
        style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-repeat': 'no-repeat',
            'background-position': 'top left',
        },
    },
});

const getAdvancedTemplateScratchTemplate = () => ({
    page: {
        template: { version: '2.0.0' },
        title: '',
        description: '',
        body: {
            content: {
                style: {
                    color: '#000000',
                    'font-family': 'Arial, Helvetica Neue, Helvetica, sans-serif',
                },
                computedStyle: {
                    linkColor: '#0068A5',
                    messageWidth: '500px',
                    messageBackgroundColor: 'transparent',
                },
            },
            webFonts: [],
            container: { style: { 'background-color': '#FFFFFF' } },
        },
        rows: [getAdvancedTemplateEmptyRow(), getAdvancedTemplateFooterRow()],
    },
});

const getAdvancedTemplateWithFooter = (template: AdvancedMessageTemplateJson) => {
    return {
        ...template,
        page: {
            ...template.page,
            rows: [...template.page.rows, getAdvancedTemplateFooterRow()],
        },
    };
};

export {
    getAdvancedTemplateWithFooter,
    getAdvancedTemplateScratchTemplate,
    advancedTemplateCategories,
};
export type { AdvancedTemplateCategory };
